module.exports = __webpack_public_path__ + "img/information_message_of_love_mob@2x.bb7b6ac.webp";